import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const DataAnalytics = () => (
  <motion.div className="industry-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    <div className="industry-content">
      <h1>Data Analytics & BI</h1>
      <p>Unlocking insights from your data using dashboards, predictive models, and intelligent reporting.</p>
      <ul className="bullet-points">
        <li>📊 Dashboards & visualization</li>
        <li>📈 Business intelligence reporting</li>
        <li>📦 Data pipelines & ETL</li>
        <li>🤖 Predictive analytics & ML</li>
      </ul>
    </div>
  </motion.div>
);

export default DataAnalytics;
